/*
Mixin for record live search. Available classes: Needy, Foundation, Contractor, Cause
*/

export const SearchesMixin = (controller, klass = 'Needy') => {
  const NEEDIES_SEARCH_PATH = '/panel/needies/searches?q={query}&';
  const ORGANIZATIONS_SEARCH_PATH = '/panel/organizations/searches?q={query}&';
  const CAUSES_SEARCH_PATH = '/panel/causes/searches?q={query}&';
  const CONTRACTORS_SEARCH_PATH = '/panel/contractors/searches?q={query}&';
  const INVOICES_CONTRACTORS_SEARCH_PATH =
    '/panel/invoices/contractors/searches?q={query}&';

  Object.assign(controller, {
    initializeSearch(params, callbacks, customTemplates = {}) {
      $(params.selector).search({
        apiSettings: { url: this.buildQueryUrl(params.query) },
        searchDelay: 500,
        maxResults: 5,
        error: { noResults: params.noResultsMessage },
        templates: {
          message: (msg, type) => {
            return $.fn.search.settings.templates
              .message(msg, type)
              .replaceAll('No Results', 'Brak');
          },
          ...customTemplates,
        },
        ...callbacks,
      });
    },

    buildQueryUrl(queryParams) {
      const params = Object.entries(queryParams)
        .map(([param, value], i) => `${param}=${value}`)
        .join('&');

      if (!klass) {
        klass = 'Needy';
      }

      switch (klass) {
        case 'Needy':
          return NEEDIES_SEARCH_PATH + params;
        case 'Organization':
          return ORGANIZATIONS_SEARCH_PATH + params;
        case 'Cause':
          return CAUSES_SEARCH_PATH + params;
        case 'Contractor':
          return CONTRACTORS_SEARCH_PATH + params;
        case 'Invoices::Contractor':
          return INVOICES_CONTRACTORS_SEARCH_PATH + params;
      }
    },
  });
};
